import * as React from "react";

import getGenePalette from "../getGenePalette";
import GeneSnpShapes from "../shared/GeneSnpShapes";
import { geneGroupProps } from "../shared/geneGroupProps";
import getGeneSnpCount from "../shared/getGeneSnpCount";

export const MethylationNitricOxideDiagramContent = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick
}) => {
  const dhfr = getGenePalette(geneColors.DHFR);
  const nos3 = getGenePalette(geneColors.NOS3);
  const sod1_3 = getGenePalette(geneColors["SOD1/3"]);
  const gpx1 = getGenePalette(geneColors.GPX1);

  return (
    <>
      <g id="diagram" clipPath="url(#clip1_18291_211493)">
        <rect width={1424} height={869} transform="translate(0 176)" fill="white" />
        <g id="methylation-nitric-oxide-diagram">
          <rect width={1424} height={869} transform="translate(0 176)" fill="white" />
          <g id="lines_2">
            <path
              id="Vector_3"
              d="M313 256.042L320 260.083V252L313 256.042ZM478.3 256.742H479V255.342H478.3V256.042V256.742ZM319.3 256.042V256.742L478.3 256.742V256.042V255.342L319.3 255.342V256.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_3">
            <text
              id="Line Label"
              transform="translate(697 508)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={71.9385} y={16.767}>
                Decrease BH4
              </tspan>
            </text>
            <path
              id="Vector_4"
              d="M697.7 535.7L931.3 535.7"
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeLinecap="round"
              strokeDasharray="4 4"
            />
          </g>
          <g id="lines_4">
            <path
              id="Vector_5"
              d="M561 256.042L568 260.083V252L561 256.042ZM627.3 256.742H628V255.342H627.3V256.042V256.742ZM567.3 256.042V256.742H627.3V256.042V255.342L567.3 255.342V256.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_5">
            <path
              id="Vector_6"
              d="M712 256.042L719 260.083V252L712 256.042ZM794.3 256.742H795V255.342H794.3V256.042V256.742ZM718.3 256.042V256.742H794.3V256.042V255.342L718.3 255.342V256.042Z"
              fill="#E44C4B"
            />
          </g>
          <g id="lines_6">
            <text
              id="Line Label_2"
              transform="translate(248 380) rotate(-90)"
              fill="#1A1A1A"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={18.666} y={16.767}>
                Removes
              </tspan>
            </text>
            <path
              id="Vector_7"
              d="M278.341 379.3L278.341 380L279.741 380L279.741 379.3L279.041 379.3L278.341 379.3ZM279.041 285L275 292L283.082 292L279.041 285ZM279.041 379.3L279.741 379.3L279.741 291.3L279.041 291.3L278.341 291.3L278.341 379.3L279.041 379.3Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_7">
            <path
              id="Vector_8"
              d="M1107.74 505.7L1107.74 505L1106.34 505L1106.34 505.7L1107.04 505.7L1107.74 505.7ZM1107.04 583L1111.08 576L1103 576L1107.04 583ZM1107.04 505.7L1106.34 505.7L1106.34 576.7L1107.04 576.7L1107.74 576.7L1107.74 505.7L1107.04 505.7Z"
              fill="#1A1A1A"
            />
          </g>
          <g id="lines_8">
            <path
              id="Vector_9"
              d="M274.742 583.7C274.742 583.314 274.429 583 274.042 583C273.655 583 273.342 583.314 273.342 583.7L274.042 583.7L274.742 583.7ZM274.042 641L278.083 634L270.001 634L274.042 641ZM273.342 585.747C273.342 586.133 273.655 586.447 274.042 586.447C274.429 586.447 274.742 586.133 274.742 585.747L274.042 585.747L273.342 585.747ZM274.742 589.839C274.742 589.453 274.429 589.139 274.042 589.139C273.655 589.139 273.342 589.453 273.342 589.839L274.042 589.839L274.742 589.839ZM273.342 593.932C273.342 594.319 273.655 594.632 274.042 594.632C274.429 594.632 274.742 594.319 274.742 593.932L274.042 593.932L273.342 593.932ZM274.742 598.025C274.742 597.639 274.429 597.325 274.042 597.325C273.655 597.325 273.342 597.639 273.342 598.025L274.042 598.025L274.742 598.025ZM273.342 602.118C273.342 602.505 273.655 602.818 274.042 602.818C274.429 602.818 274.742 602.505 274.742 602.118L274.042 602.118L273.342 602.118ZM274.742 606.211C274.742 605.824 274.429 605.511 274.042 605.511C273.655 605.511 273.342 605.824 273.342 606.211L274.042 606.211L274.742 606.211ZM273.342 610.304C273.342 610.69 273.655 611.004 274.042 611.004C274.429 611.004 274.742 610.69 274.742 610.304L274.042 610.304L273.342 610.304ZM274.742 614.397C274.742 614.01 274.429 613.697 274.042 613.697C273.655 613.697 273.342 614.01 273.342 614.397L274.042 614.397L274.742 614.397ZM273.342 618.489C273.342 618.876 273.655 619.189 274.042 619.189C274.429 619.189 274.742 618.876 274.742 618.489L274.042 618.489L273.342 618.489ZM274.742 622.582C274.742 622.196 274.429 621.882 274.042 621.882C273.655 621.882 273.342 622.196 273.342 622.582L274.042 622.582L274.742 622.582ZM273.342 626.675C273.342 627.062 273.655 627.375 274.042 627.375C274.429 627.375 274.742 627.062 274.742 626.675L274.042 626.675L273.342 626.675ZM274.742 630.768C274.742 630.381 274.429 630.068 274.042 630.068C273.655 630.068 273.342 630.381 273.342 630.768L274.042 630.768L274.742 630.768ZM273.342 634.861C273.342 635.248 273.655 635.561 274.042 635.561C274.429 635.561 274.742 635.248 274.742 634.861L274.042 634.861L273.342 634.861ZM274.742 638.954C274.742 638.567 274.429 638.254 274.042 638.254C273.655 638.254 273.342 638.567 273.342 638.954L274.042 638.954L274.742 638.954ZM274.042 583.7L273.342 583.7L273.342 585.747L274.042 585.747L274.742 585.747L274.742 583.7L274.042 583.7ZM274.042 589.839L273.342 589.839L273.342 593.932L274.042 593.932L274.742 593.932L274.742 589.839L274.042 589.839ZM274.042 598.025L273.342 598.025L273.342 602.118L274.042 602.118L274.742 602.118L274.742 598.025L274.042 598.025ZM274.042 606.211L273.342 606.211L273.342 610.304L274.042 610.304L274.742 610.304L274.742 606.211L274.042 606.211ZM274.042 614.397L273.342 614.397L273.342 618.489L274.042 618.489L274.742 618.489L274.742 614.397L274.042 614.397ZM274.042 622.582L273.342 622.582L273.342 626.675L274.042 626.675L274.742 626.675L274.742 622.582L274.042 622.582ZM274.042 630.768L273.342 630.768L273.342 634.861L274.042 634.861L274.742 634.861L274.742 630.768L274.042 630.768Z"
              fill="#818181"
            />
          </g>
          <g id="Cofactor_3">
            <g id="diamond_2">
              <text
                id="label"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={12}
                letterSpacing="0px"
              >
                <tspan x={1131.18} y={536.086}>
                  NADPH
                </tspan>
              </text>
              <g id="Vector_10">
                <mask id="path-33-inside-2_18291_211493" fill="white">
                  <path d="M1151 507L1176 519.121V544.879L1151 557L1126 544.879V519.121L1151 507Z" />
                </mask>
                <path
                  d="M1151 507L1176 519.121V544.879L1151 557L1126 544.879V519.121L1151 507Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-33-inside-2_18291_211493)"
                />
              </g>
            </g>
          </g>
          <g id="Cofactor_4">
            <g id="diamond_3">
              <text
                id="label_2"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={14}
                letterSpacing="0em"
              >
                <tspan x={327.909} y={705.767}>
                  BH4
                </tspan>
              </text>
              <g id="Vector_11">
                <mask id="path-35-inside-3_18291_211493" fill="white">
                  <path d="M341 676L366 688.121V713.879L341 726L316 713.879V688.121L341 676Z" />
                </mask>
                <path
                  d="M341 676L366 688.121V713.879L341 726L316 713.879V688.121L341 676Z"
                  stroke="#1A1A1A"
                  strokeWidth={2}
                  mask="url(#path-35-inside-3_18291_211493)"
                />
              </g>
            </g>
          </g>
          <g id="Report titles">
            <rect width={39} height={28} transform="translate(253 235)" fill="white" />
            <g id="25-Hydroxy Vitamin D">
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={253.371} y={255.129}>
                  H
                </tspan>
                <tspan x={271.537} y={255.129}>
                  O
                </tspan>
              </text>
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={265.518} y={255.129}>
                  {"\u2082"}
                </tspan>
                <tspan x={285.933} y={255.129}>
                  {"\u2082"}
                </tspan>
              </text>
            </g>
          </g>
          <g id="Report titles_2">
            <rect width={79} height={52} transform="translate(628 235)" fill="white" />
            <g id="25-Hydroxy Vitamin D_2">
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={651.109} y={255.129}>
                  O
                </tspan>
              </text>
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={665.506} y={255.129}>
                  {"\u2082 "}
                </tspan>
              </text>
              <text
                fill="#E44C4B"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={674.549} y={255.129}>
                  {"\u2022\u207b"}
                </tspan>
              </text>
            </g>
            <text
              id="Sub Label"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={14}
              letterSpacing="0em"
            >
              <tspan x={628.446} y={279.76}>
                Superoxides
              </tspan>
            </text>
          </g>
          <text
            id="Toxic"
            fill="#E44C4B"
            style={{ whiteSpace: "pre" }}
            xmlSpace="preserve"
            fontFamily="Gilroy W05 Regular"
            fontSize={16}
            letterSpacing="0em"
          >
            <tspan x={739.188} y={275.44}>
              Toxic
            </tspan>
          </text>
          <g id="Report titles_3">
            <text
              id="25-Hydroxy Vitamin D_3"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1198.86} y={439.12}>
                {"Folic Acid "}
              </tspan>
              <tspan x={1195.29} y={467.12}>
                and folate
              </tspan>
            </text>
          </g>
          <g id="Report titles_4">
            <text
              id="25-Hydroxy Vitamin D_4"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1091.27} y={443.12}>
                DHF
              </tspan>
            </text>
          </g>
          <g id="Report titles_5">
            <text
              id="25-Hydroxy Vitamin D_5"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={810.274} y={400.12}>
                STRESS
              </tspan>
            </text>
          </g>
          <g id="Report titles_6">
            <text
              id="25-Hydroxy Vitamin D_6"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={1091.39} y={604.12}>
                THF
              </tspan>
            </text>
          </g>
          <g id="Report titles_7">
            <rect width={105} height={20} transform="translate(795 204)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_7"
              fill="black"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={12}
              letterSpacing="0px"
            >
              <tspan x={795.094} y={218.08}>
                Uncoupled Enzyme
              </tspan>
            </text>
          </g>
          <g id="Report titles_8">
            <rect x={511.7} y={324.7} width={235.6} height={226.6} fill="white" />
            <rect
              x={511.7}
              y={324.7}
              width={235.6}
              height={226.6}
              stroke="#E44C4B"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <text
              id="25-Hydroxy Vitamin D_8"
              fill="#E44C4B"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Regular"
              fontSize={16}
              letterSpacing="0em"
            >
              <tspan x={527} y={359.44}>
                {"BPA "}
              </tspan>
              <tspan x={527} y={387.44}>
                {"Smoking "}
              </tspan>
              <tspan x={527} y={415.44}>
                {"Aluminium "}
              </tspan>
              <tspan x={527} y={443.44}>
                {"Chemotherapy "}
              </tspan>
              <tspan x={527} y={471.44}>
                {"Perfluorinated substances "}
              </tspan>
              <tspan x={527} y={499.44}>
                {"Chronic viral infections (long "}
              </tspan>
              <tspan x={527} y={527.44}>
                COVID, hepatitis etc.)
              </tspan>
            </text>
          </g>
          <g id="Report titles_9">
            <rect width={49} height={28} transform="translate(939 332)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_9"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={947.144} y={352.129}>
                BH2
              </tspan>
            </text>
          </g>
          <g id="report-label">
            <g id="Report titles_10">
              <rect width={66} height={28} transform="translate(242 644)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_10"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={242.05} y={664.12}>
                  Arginine
                </tspan>
              </text>
            </g>
            <g id="lines_9">
              <path
                id="Vector_12"
                d="M275.659 676.7L275.659 676L274.259 676L274.259 676.7L274.959 676.7L275.659 676.7ZM274.959 797L279 790L270.918 790L274.959 797ZM274.959 676.7L274.259 676.7L274.259 790.7L274.959 790.7L275.659 790.7L275.659 676.7L274.959 676.7Z"
                fill="#1A1A1A"
              />
            </g>
          </g>
          <g id="report-label_2">
            <g id="Report titles_11">
              <rect width={137} height={28} transform="translate(206 799)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_11"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={18}
                letterSpacing="0em"
              >
                <tspan x={206.446} y={819.12}>
                  Nitric Oxide (NO)
                </tspan>
              </text>
            </g>
            <g id="lines_10">
              <path
                id="Vector_13"
                d="M275.159 831.7C275.159 831.314 274.846 831 274.459 831C274.072 831 273.759 831.314 273.759 831.7L274.459 831.7L275.159 831.7ZM274.459 942L278.5 935L270.418 935L274.459 942ZM273.759 833.67C273.759 834.056 274.072 834.37 274.459 834.37C274.846 834.37 275.159 834.056 275.159 833.67L274.459 833.67L273.759 833.67ZM275.159 837.609C275.159 837.223 274.846 836.909 274.459 836.909C274.072 836.909 273.759 837.223 273.759 837.609L274.459 837.609L275.159 837.609ZM273.759 841.548C273.759 841.935 274.072 842.248 274.459 842.248C274.846 842.248 275.159 841.935 275.159 841.548L274.459 841.548L273.759 841.548ZM275.159 845.488C275.159 845.101 274.846 844.788 274.459 844.788C274.072 844.788 273.759 845.101 273.759 845.488L274.459 845.488L275.159 845.488ZM273.759 849.427C273.759 849.814 274.072 850.127 274.459 850.127C274.846 850.127 275.159 849.814 275.159 849.427L274.459 849.427L273.759 849.427ZM275.159 853.366C275.159 852.98 274.846 852.666 274.459 852.666C274.072 852.666 273.759 852.98 273.759 853.366L274.459 853.366L275.159 853.366ZM273.759 857.306C273.759 857.692 274.072 858.006 274.459 858.006C274.846 858.006 275.159 857.692 275.159 857.306L274.459 857.306L273.759 857.306ZM275.159 861.245C275.159 860.858 274.846 860.545 274.459 860.545C274.072 860.545 273.759 860.858 273.759 861.245L274.459 861.245L275.159 861.245ZM273.759 865.184C273.759 865.571 274.072 865.884 274.459 865.884C274.846 865.884 275.159 865.571 275.159 865.184L274.459 865.184L273.759 865.184ZM275.159 869.123C275.159 868.737 274.846 868.423 274.459 868.423C274.072 868.423 273.759 868.737 273.759 869.123L274.459 869.123L275.159 869.123ZM273.759 873.063C273.759 873.449 274.072 873.763 274.459 873.763C274.846 873.763 275.159 873.449 275.159 873.063L274.459 873.063L273.759 873.063ZM275.159 877.002C275.159 876.615 274.846 876.302 274.459 876.302C274.072 876.302 273.759 876.615 273.759 877.002L274.459 877.002L275.159 877.002ZM273.759 880.941C273.759 881.328 274.072 881.641 274.459 881.641C274.846 881.641 275.159 881.328 275.159 880.941L274.459 880.941L273.759 880.941ZM275.159 884.881C275.159 884.494 274.846 884.181 274.459 884.181C274.072 884.181 273.759 884.494 273.759 884.881L274.459 884.881L275.159 884.881ZM273.759 888.82C273.759 889.206 274.072 889.52 274.459 889.52C274.846 889.52 275.159 889.206 275.159 888.82L274.459 888.82L273.759 888.82ZM275.159 892.759C275.159 892.373 274.846 892.059 274.459 892.059C274.072 892.059 273.759 892.373 273.759 892.759L274.459 892.759L275.159 892.759ZM273.759 896.698C273.759 897.085 274.072 897.398 274.459 897.398C274.846 897.398 275.159 897.085 275.159 896.698L274.459 896.698L273.759 896.698ZM275.159 900.638C275.159 900.251 274.846 899.938 274.459 899.938C274.072 899.938 273.759 900.251 273.759 900.638L274.459 900.638L275.159 900.638ZM273.759 904.577C273.759 904.964 274.072 905.277 274.459 905.277C274.846 905.277 275.159 904.964 275.159 904.577L274.459 904.577L273.759 904.577ZM275.159 908.516C275.159 908.13 274.846 907.816 274.459 907.816C274.072 907.816 273.759 908.13 273.759 908.516L274.459 908.516L275.159 908.516ZM273.759 912.456C273.759 912.842 274.072 913.156 274.459 913.156C274.846 913.156 275.159 912.842 275.159 912.456L274.459 912.456L273.759 912.456ZM275.159 916.395C275.159 916.008 274.846 915.695 274.459 915.695C274.072 915.695 273.759 916.008 273.759 916.395L274.459 916.395L275.159 916.395ZM273.759 920.334C273.759 920.721 274.072 921.034 274.459 921.034C274.846 921.034 275.159 920.721 275.159 920.334L274.459 920.334L273.759 920.334ZM275.159 924.273C275.159 923.887 274.846 923.573 274.459 923.573C274.072 923.573 273.759 923.887 273.759 924.273L274.459 924.273L275.159 924.273ZM273.759 928.213C273.759 928.599 274.072 928.913 274.459 928.913C274.846 928.913 275.159 928.599 275.159 928.213L274.459 928.213L273.759 928.213ZM275.159 932.152C275.159 931.765 274.846 931.452 274.459 931.452C274.072 931.452 273.759 931.765 273.759 932.152L274.459 932.152L275.159 932.152ZM273.759 936.091C273.759 936.478 274.072 936.791 274.459 936.791C274.846 936.791 275.159 936.478 275.159 936.091L274.459 936.091L273.759 936.091ZM275.159 940.031C275.159 939.644 274.846 939.331 274.459 939.331C274.072 939.331 273.759 939.644 273.759 940.031L274.459 940.031L275.159 940.031ZM274.459 831.7L273.759 831.7L273.759 833.67L274.459 833.67L275.159 833.67L275.159 831.7L274.459 831.7ZM274.459 837.609L273.759 837.609L273.759 841.548L274.459 841.548L275.159 841.548L275.159 837.609L274.459 837.609ZM274.459 845.488L273.759 845.488L273.759 849.427L274.459 849.427L275.159 849.427L275.159 845.488L274.459 845.488ZM274.459 853.366L273.759 853.366L273.759 857.306L274.459 857.306L275.159 857.306L275.159 853.366L274.459 853.366ZM274.459 861.245L273.759 861.245L273.759 865.184L274.459 865.184L275.159 865.184L275.159 861.245L274.459 861.245ZM274.459 869.123L273.759 869.123L273.759 873.063L274.459 873.063L275.159 873.063L275.159 869.123L274.459 869.123ZM274.459 877.002L273.759 877.002L273.759 880.941L274.459 880.941L275.159 880.941L275.159 877.002L274.459 877.002ZM274.459 884.881L273.759 884.881L273.759 888.82L274.459 888.82L275.159 888.82L275.159 884.881L274.459 884.881ZM274.459 892.759L273.759 892.759L273.759 896.698L274.459 896.698L275.159 896.698L275.159 892.759L274.459 892.759ZM274.459 900.638L273.759 900.638L273.759 904.577L274.459 904.577L275.159 904.577L275.159 900.638L274.459 900.638ZM274.459 908.516L273.759 908.516L273.759 912.456L274.459 912.456L275.159 912.456L275.159 908.516L274.459 908.516ZM274.459 916.395L273.759 916.395L273.759 920.334L274.459 920.334L275.159 920.334L275.159 916.395L274.459 916.395ZM274.459 924.273L273.759 924.273L273.759 928.213L274.459 928.213L275.159 928.213L275.159 924.273L274.459 924.273ZM274.459 932.152L273.759 932.152L273.759 936.091L274.459 936.091L275.159 936.091L275.159 932.152L274.459 932.152Z"
                fill="#818181"
              />
            </g>
          </g>
          <g id="Frame 466">
            <path
              d="M353 950V950.7H355C355.756 950.7 356.493 950.774 357.206 950.915L357.341 950.229C358.915 950.54 360.378 951.16 361.666 952.021L361.278 952.603C362.511 953.428 363.572 954.489 364.397 955.722L364.978 955.333C365.84 956.621 366.459 958.084 366.771 959.658L366.085 959.794C366.226 960.507 366.3 961.244 366.3 962V963.667H367V967H366.3V970.333H367V973.667H366.3V977H367V980.333H366.3V982C366.3 982.756 366.226 983.493 366.085 984.206L366.771 984.341C366.459 985.915 365.84 987.378 364.978 988.666L364.397 988.278C363.572 989.511 362.511 990.572 361.278 991.397L361.666 991.978C360.378 992.84 358.915 993.459 357.341 993.771L357.206 993.085C356.493 993.226 355.756 993.3 355 993.3H353V994H349V993.3H345V994H341V993.3H337V994H333V993.3H329V994H325V993.3H321V994H317V993.3H313V994H309V993.3H305V994H301V993.3H297V994H293V993.3H289V994H285V993.3H281V994H277V993.3H273V994H269V993.3H265V994H261V993.3H257V994H253V993.3H249V994H245V993.3H241V994H237V993.3H233V994H229V993.3H225V994H221V993.3H217V994H213V993.3H209V994H205V993.3H201V994H197V993.3H195C194.244 993.3 193.507 993.226 192.794 993.085L192.658 993.771C191.084 993.459 189.621 992.84 188.333 991.978L188.722 991.397C187.489 990.572 186.428 989.511 185.603 988.278L185.021 988.666C184.16 987.378 183.54 985.915 183.229 984.341L183.915 984.206C183.809 983.671 183.741 983.123 183.714 982.563L183.7 982V980.333H183V977H183.7V973.667H183V970.333H183.7V967H183V963.667H183.7V962C183.7 961.244 183.774 960.507 183.915 959.794L183.229 959.658C183.54 958.084 184.16 956.621 185.021 955.333L185.603 955.722C186.428 954.489 187.489 953.428 188.722 952.603L188.333 952.021C189.621 951.16 191.084 950.54 192.658 950.229L192.794 950.915C193.507 950.774 194.244 950.7 195 950.7H197V950H201V950.7H205V950H209V950.7H213V950H217V950.7H221V950H225V950.7H229V950H233V950.7H237V950H241V950.7H245V950H249V950.7H253V950H257V950.7H261V950H265V950.7H269V950H273V950.7H277V950H281V950.7H285V950H289V950.7H293V950H297V950.7H301V950H305V950.7H309V950H313V950.7H317V950H321V950.7H325V950H329V950.7H333V950H337V950.7H341V950H345V950.7H349V950H353Z"
              stroke="#5220DD"
              strokeWidth={1.4}
              strokeDasharray="4 4"
            />
            <g id="Rich Text Block">
              <text
                id="Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={199.445} y={977.448}>
                  Healthy vasodilation
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Ellipse 10"
            d="M1114.97 421L1119.52 417.451L1114.17 415.282L1114.97 421ZM1116.66 416.832L1117.11 417.036C1127.25 394.326 1150.03 378.5 1176.5 378.5V378V377.5C1149.62 377.5 1126.49 393.572 1116.2 416.629L1116.66 416.832ZM1176.5 378V378.5C1204.55 378.5 1228.46 396.271 1237.56 421.172L1238.03 421L1238.5 420.828C1229.26 395.546 1204.99 377.5 1176.5 377.5V378Z"
            fill="#282828"
          />
          <path
            id="Vector 431"
            d="M274 582H802.257L931 539"
            stroke="#818181"
            strokeWidth={1.4}
            strokeDasharray="4 4"
          />
          <g id="report-label_3">
            <g id="Report titles_12">
              <rect width={64} height={28} transform="translate(142 771)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_12"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={142.336} y={790.44}>
                  Citrulline
                </tspan>
              </text>
            </g>
          </g>
          <g id="report-label_4">
            <g id="Report titles_13">
              <rect width={124} height={28} transform="translate(292 765)" fill="white" />
              <text
                id="25-Hydroxy Vitamin D_13"
                fill="#1A1A1A"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Regular"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={292.32} y={784.44}>
                  Coupled Enzyme
                </tspan>
              </text>
            </g>
          </g>
          <path
            id="Ellipse 9"
            d="M988 534L995.847 535.937L993.601 528.172L988 534ZM1059 443H1058.3C1058.3 484.329 1031.27 519.378 993.84 531.582L994.057 532.248L994.274 532.913C1032.26 520.528 1059.7 484.956 1059.7 443H1059ZM988 352L987.828 352.679C1028.34 362.939 1058.3 399.49 1058.3 443H1059H1059.7C1059.7 398.829 1029.29 361.734 988.172 351.321L988 352Z"
            fill="#282828"
          />
          <path
            id="Vector 432"
            d="M217 792L224.313 795.443L223.638 787.389L217 792ZM271 769L270.443 768.576C265.61 774.919 249.666 787.722 223.198 790.779L223.278 791.474L223.359 792.17C250.181 789.072 266.479 776.089 271.557 769.424L271 769Z"
            fill="#282828"
          />
          <path
            id="Ellipse 8"
            d="M938 353L930.081 351.383L932.64 359.05L938 353ZM936.35 533L936.561 532.333C898.968 520.427 871.7 485.048 871.7 443.253H871H870.3C870.3 485.67 897.975 521.581 936.138 533.667L936.35 533ZM871 443.253H871.7C871.7 403.067 896.91 368.812 932.268 355.651L932.024 354.995L931.779 354.339C895.886 367.699 870.3 402.468 870.3 443.253H871Z"
            fill="#282828"
          />
          <path id="Vector 430" d="M900 256H963V334" stroke="#E44C4B" strokeWidth={1.4} />
          <g id="Report titles_14">
            <rect width={50} height={28} transform="translate(939 516)" fill="white" />
            <text
              id="25-Hydroxy Vitamin D_14"
              fill="#282828"
              style={{ whiteSpace: "pre" }}
              xmlSpace="preserve"
              fontFamily="Gilroy W05 Medium"
              fontSize={18}
              letterSpacing="0em"
            >
              <tspan x={947.169} y={536.129}>
                BH4
              </tspan>
            </text>
          </g>
          <g id="gene-DHFR" {...geneGroupProps("DHFR", onGeneClick)}>
            <g id="gene-lozenge_5">
              <path
                d="M1055 463C1055 460.791 1056.79 459 1059 459H1151C1153.21 459 1155 460.791 1155 463V491C1155 493.209 1153.21 495 1151 495H1059C1056.79 495 1055 493.209 1055 491V463Z"
                fill={dhfr.lozengeFill}
              />
              <text
                id="gene-lozenge-label"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={1084.84} y={482.448}>
                  DHFR
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="dhfr"
              groupId="gene-snps"
              genePalette={dhfr}
              startX={1063}
              startY={497}
              snpCount={getGeneSnpCount("DHFR", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_6">
              <path
                d="M225 723C225 720.791 226.791 719 229 719H321C323.209 719 325 720.791 325 723V751C325 753.209 323.209 755 321 755H229C226.791 755 225 753.209 225 751V723Z"
                fill={nos3.lozengeFill}
              />
              <text
                id="gene-lozenge-label_2"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={254.477} y={742.448}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3"
              groupId="gene-snps_2"
              genePalette={nos3}
              startX={233}
              startY={757}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-NOS3_2" {...geneGroupProps("NOS3", onGeneClick)}>
            <g id="gene-lozenge_7">
              <path
                d="M795 241C795 238.791 796.791 237 799 237H891C893.209 237 895 238.791 895 241V269C895 271.209 893.209 273 891 273H799C796.791 273 795 271.209 795 269V241Z"
                fill={nos3.lozengeFill}
              />
              <text
                id="gene-lozenge-label_3"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={824.477} y={260.448}>
                  NOS3
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="nos3-2"
              groupId="gene-snps_3"
              genePalette={nos3}
              startX={803}
              startY={275}
              snpCount={getGeneSnpCount("NOS3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-SOD1/3" {...geneGroupProps("SOD1/3", onGeneClick)}>
            <g id="gene-lozenge_8">
              <path
                d="M461 241C461 238.791 462.791 237 465 237H557C559.209 237 561 238.791 561 241V269C561 271.209 559.209 273 557 273H465C462.791 273 461 271.209 461 269V241Z"
                fill={sod1_3.lozengeFill}
              />
              <text
                id="gene-lozenge-label_4"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={482.992} y={260.448}>
                  SOD1/3
                </tspan>
              </text>
              <path
                id="*_3"
                d="M571.748 233.406V235.824L567.818 235.695L570.064 238.934L567.861 240.23L565.874 236.731L563.887 240.23L561.684 238.934L563.93 235.695L560 235.824L560 233.406L563.93 233.535L561.684 230.296L563.887 229L565.874 232.499L567.861 229L570.064 230.296L567.818 233.535L571.748 233.406Z"
                fill="black"
              />
            </g>
            <GeneSnpShapes
              id="sod1-3"
              groupId="gene-snps_4"
              genePalette={sod1_3}
              startX={469}
              startY={275}
              snpCount={getGeneSnpCount("SOD1/3", expectedSnps, geneColors)}
            />
          </g>
          <g id="gene-GPX1" {...geneGroupProps("GPX1", onGeneClick)}>
            <g id="gene-lozenge_9">
              <path
                d="M229 390C229 387.791 230.791 386 233 386H325C327.209 386 329 387.791 329 390V418C329 420.209 327.209 422 325 422H233C230.791 422 229 420.209 229 418V390Z"
                fill={gpx1.lozengeFill}
              />
              <text
                id="gene-lozenge-label_5"
                fill="black"
                style={{ whiteSpace: "pre" }}
                xmlSpace="preserve"
                fontFamily="Gilroy W05 Medium"
                fontSize={16}
                letterSpacing="0em"
              >
                <tspan x={260.656} y={409.448}>
                  GPX1
                </tspan>
              </text>
            </g>
            <GeneSnpShapes
              id="gpx1"
              groupId="gene-snps_5"
              genePalette={gpx1}
              startX={237}
              startY={424}
              snpCount={getGeneSnpCount("GPX1", expectedSnps, geneColors)}
            />
          </g>
        </g>
      </g>
    </>
  );
};

const SvgMethylationNitricOxideDiagram = ({
  geneColors = {},
  expectedSnps = {},
  onGeneClick,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={1424}
    height={869}
    viewBox="0 176 1424 869"
    fill="none"
    {...props}
  >
    <MethylationNitricOxideDiagramContent
      geneColors={geneColors}
      expectedSnps={expectedSnps}
      onGeneClick={onGeneClick}
    />
    <defs>
      <clipPath id="clip0_18291_211493">
        <rect width={1424} height={1045} fill="white" />
      </clipPath>
      <clipPath id="clip1_18291_211493">
        <rect width={1424} height={869} fill="white" transform="translate(0 176)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgMethylationNitricOxideDiagram;
